// ==============================
// Imports
// ==============================

// MUI Components
import AppBarSpacer from '../components/common/AppBarSpacer';
import { Box, Button } from '@mui/material';
import { EventAvailable } from '@mui/icons-material';
import PageHeader from '../components/common/PageHeader';

// Libraries
import { useState } from 'react';
import { useTranslation } from '../i18n';

// Local components
import MiniDrawer from '../components/MiniDrawer';
import TrialBookingTable from '../components/TrialBookingTable';
import QuickActions from '../components/QuickActions';

const TrialBookingLayout = () => {
  // States
  const [open, setOpen] = useState(true);
  const { t } = useTranslation();

  // ==============================
  // Render
  // ==============================
  return (
    <>
      <div className="flex h-screen">
        {/* Sidebar */}
        <MiniDrawer open={open} setOpen={setOpen} />

        {/* Main content */}
        <main className="flex-1 overflow-auto app-page-bg">
          {/* Offset for fixed AppBar (height = 64px) */}
          <AppBarSpacer />

          <div className="h-full px-6 py-4">
            <PageHeader
              title={t('trialBooking.pageTitle')}
              subtitle={t('trialBooking.pageSubtitle')}
            />

            {/* Quick-access button (same behavior as the Home card) */}
            <QuickActions>
              {(handlers) => (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    mb: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EventAvailable />}
                    onClick={handlers.openTrialBooking}
                    className="bg-blue-600 hover:bg-blue-700 !text-white font-semibold py-2 px-4 rounded"
                  >
                    {t('trialBooking.addNew')}
                  </Button>
                </Box>
              )}
            </QuickActions>

            {/* Booking table */}
            <TrialBookingTable />
          </div>
        </main>
      </div>
    </>
  );
};

export default TrialBookingLayout;
